function s(e, i = !0) {
  if (i)
    for (const r of e.children)
      s(r);
  if ("geometry" in e && e.geometry.dispose(), "material" in e)
    if (Array.isArray(e.material))
      for (const r of e.material)
        r.dispose();
    else
      e.material.dispose();
  e.removeFromParent();
}
export {
  s as dispose
};
//# sourceMappingURL=index.js.map
